import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { useLogout } from 'hooks/use-logout';
import { ModalFrame, PrimaryButton, SecondaryButton } from 'ui/kit/Kit';

/* Figma 54:12358 «Модалка выхода»: подтверждение перед выходом из всех меню кабинета. */
const LOGOUT_CONFIRM_EVENT = 'myteacher:logout-confirm';

export const requestLogout = () => {
  window.dispatchEvent(new Event(LOGOUT_CONFIRM_EVENT));
};

export function LogoutConfirmHost() {
  const [open, setOpen] = useState(false);
  const logout = useLogout();

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(LOGOUT_CONFIRM_EVENT, show);
    return () => window.removeEventListener(LOGOUT_CONFIRM_EVENT, show);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!open) return null;

  return createPortal(
    <ModalFrame
      title='Выход из аккаунта'
      text='Вы выйдете из кабинета на этом устройстве.'
      onClose={() => setOpen(false)}
    >
      <SecondaryButton type='button' onClick={() => setOpen(false)}>
        Отмена
      </SecondaryButton>
      <PrimaryButton
        type='button'
        disabled={logout.isPending}
        onClick={() => {
          setOpen(false);
          logout.mutate();
        }}
      >
        Выйти
      </PrimaryButton>
    </ModalFrame>,
    document.body,
  );
}
